import { HStack, IconButton } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';

import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';
import Tooltip from 'components/v4/Tooltip';
import ActionsCellWrapper from 'components/tables/AGGrid/ActionsCellWrapper';

/**
 * Builds the AG Grid column definitions for the Locations table.
 *
 * @param {object}   params
 * @param {boolean}  params.darkMode        Current dark mode state.
 * @param {function} params.onEditLocation  Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getLocationsTableColumns = ({ darkMode, onEditLocation }) => [
    {
        headerName: 'ID',
        field: 'id',
        cellRenderer: CopyCellRenderer,
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Location',
        field: 'location',
        cellRenderer: CopyCellRenderer,
        cellStyle: () => ({ width: '100%' }),
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsCellWrapper>
                <HStack
                    spacing={0}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    height="100%">
                    <Tooltip label="Edit Location">
                        <IconButton
                            icon={
                                <BsThreeDotsVertical
                                    fill={darkMode ? 'white' : 'black'}
                                />
                            }
                            aria-label="Edit"
                            variant="ghost"
                            onClick={() => {
                                onEditLocation(params.data);
                            }}
                            _hover={{
                                bg: darkMode
                                    ? 'whiteAlpha.200'
                                    : 'blackAlpha.100',
                            }}
                            _active={{
                                bg: darkMode
                                    ? 'whiteAlpha.300'
                                    : 'blackAlpha.200',
                            }}
                            _focus={{ boxShadow: 'none' }}
                        />
                    </Tooltip>
                </HStack>
            </ActionsCellWrapper>
        ),
    },
];
